var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:_vm.className,staticClass:"chinamap_effect",style:({ width: (this.width || 400) + 'px', height: (this.height || 400) + 'px' })})])}
var staticRenderFns = []

export { render, staticRenderFns }